import { ALL_USER_ROLES, USER_GROUPS } from '../../constants/roles/userRoleTypes';

const {
    ASSISTER,
    BROKER,
    INDIVIDUAL,
    ADMIN,
    BA,
    SECURITY,
    RECON,
    APPEALS,
    
} = ALL_USER_ROLES;

const { CSR_GROUP, AGENCY_GROUP } = USER_GROUPS;

export const fields = {
    AGENT_FIRST_NAME : 'agentFirstName',
    AGENT_LAST_NAME : 'agentLastName',
    CEC_FIRST_NAME : 'cecFirstName',
    CEC_LAST_NAME : 'cecLastName',
    AGENT_LICENCE_NUMBER : 'agentLicenseNumber',
    AGENT_CEC_NAME : 'agentCecName',
    AGENT_NAME : 'agentName',
    BUSINESS_NAME : 'businessName',
    TYPE : 'type',
    REASON : 'reason',
    DESIGNATION_START_DATE : 'designationStartDate',
    DESIGNATION_END_DATE : 'designationEndDate',
    HOUSEHOLD_PRIMARY : 'householdPrimary',
    HOUSEHOLD_CASE_ID : 'householdCaseId'
};


export const labelNames = {
    [fields.AGENT_FIRST_NAME]: 'common.agent_first_name',
    [fields.AGENT_LAST_NAME]: 'common.agent_last_name',
    [fields.CEC_FIRST_NAME]: 'common.cec_first_name',
    [fields.CEC_LAST_NAME]: 'common.cec_last_name',
    [fields.AGENT_LICENCE_NUMBER]: 'common.agent_licence_number',
    [fields.HOUSEHOLD_CASE_ID]: 'common.household_case_id',
    [fields.AGENT_CEC_NAME]: 'common.agent_cec_name',
    [fields.AGENT_NAME]: 'common.agent',
    [fields.BUSINESS_NAME]: 'common.business_name',
    [fields.TYPE]: 'common.type',
    [fields.REASON]: 'common.reason_for_end',
    [fields.DESIGNATION_START_DATE]: 'delegation.label.delegation_start_date',
    [fields.DESIGNATION_END_DATE]: 'delegation.label.delegation_end_date',
    [fields.HOUSEHOLD_PRIMARY]: 'common.household_primary'
};

export const tableHeadersByRole = {
    [CSR_GROUP]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [INDIVIDUAL]: [
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [AGENCY_GROUP]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [BROKER]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [ASSISTER]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [ADMIN]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [BA]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [SECURITY]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [RECON]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ],
    [APPEALS]: [
        fields.HOUSEHOLD_PRIMARY,
        fields.HOUSEHOLD_CASE_ID,
        fields.AGENT_CEC_NAME,
        fields.TYPE,
        fields.AGENT_LICENCE_NUMBER,
        fields.BUSINESS_NAME,
        fields.DESIGNATION_START_DATE,
        fields.DESIGNATION_END_DATE,
        fields.REASON
    ]
};

export const filtersByRole = {
    [INDIVIDUAL]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME
    ],
    [CSR_GROUP]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ],
    [AGENCY_GROUP]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.HOUSEHOLD_CASE_ID
    ],
    [BROKER]: [
        fields.HOUSEHOLD_CASE_ID
    ],
    [ASSISTER]: [
        fields.HOUSEHOLD_CASE_ID
    ],
    [ADMIN]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ],
    [BA]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ],
    [SECURITY]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ],
    [RECON]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ],
    [APPEALS]: [
        fields.AGENT_FIRST_NAME,
        fields.AGENT_LAST_NAME,
        fields.AGENT_LICENCE_NUMBER,
        fields.CEC_FIRST_NAME,
        fields.CEC_LAST_NAME,
        fields.HOUSEHOLD_CASE_ID
    ]
};

export const filterInputsMaxLength = {
    [fields.AGENT_FIRST_NAME] : 50,
    [fields.AGENT_LAST_NAME]: 50,
    [fields.CEC_FIRST_NAME] : 50,
    [fields.CEC_LAST_NAME] : 50,
    [fields.AGENT_LICENCE_NUMBER] : 11,
    [fields.HOUSEHOLD_CASE_ID]: null
};


export const DELEGATION_REASONS = {
    AGENT_CEC_CERTIFICATION_ENDED:	'delegation.reasons.certification_ended',
    AGENT_CEC_INITIATED_DEDESIGNATION:	'delegation.reasons.initiated_de_designation',
    CC_ADMIN_STAFF: 'delegation.reasons.cc_admin_staff',
    CONSUMER_REQUESTED_CANCELLATION:	'delegation.reasons.cancellation',
    CONSUMER_REQUESTED_CHANGE: 'delegation.reasons.change',
    TRANSFER_WITHIN_AGENCY_ENTITY: 'delegation.reasons.transfer',
    ACCELERATED_CONSUMER_DELEGATION_CONSENT: 'delegation.reasons.accelerated',
    EDE_NO_NPN_RECEIVED:'delegation.reasons.ede_no_npn_received'
};

export const DELEGATION_HEADER_TYPES = {
    [INDIVIDUAL]: 'delegation_header',
    [BROKER]: 'delegation_header--2',
    [AGENCY_GROUP]: 'delegation_header--3',
    [CSR_GROUP]: 'delegation_header--3',
    [ASSISTER]: 'delegation_header--2',
    [ADMIN]: 'delegation_header--3',
    [BA]: 'delegation_header--3',
    [SECURITY]: 'delegation_header--3',
    [RECON]: 'delegation_header--3',
    [APPEALS]: 'delegation_header--3',
};

export const DELEGATION_ALERT_MSGS = {
    DEFAULT: 'delegation_no_results',
    CASE_ID: 'delegation_no_results.case_id'
};
export const DELEGATION_TYPE = {
    CEC: 'CEC',
    AGENT: 'Agent',
    BROKER: 'Broker',
    NAVIGATOR: 'Navigator',
};